import { cn } from '../lib/cn.js';
import { useResolvedTheme } from '../lib/theme.js';

/** Proporção da arte original (1559×1879). */
const RATIO = 1559 / 1879;

/**
 * Marca do sistema, a partir de logo.png.
 *
 * A arte original é feita para fundo escuro — capacete laranja, operário branco.
 * `apps/web/public/marca.png` é a variante para fundo claro, com o corpo em tinta;
 * `marca-invertida.png` mantém o branco. Ver design.md §2.
 *
 * Sem `inverted`, a variante segue o tema em vigor: sobre a superfície escura o
 * corpo em tinta sumiria. Com `inverted`, é sempre a branca — o caso do trilho,
 * que é escuro nos dois temas.
 */
export function BrandMark({
  size = 28,
  inverted,
  className,
}: {
  size?: number | undefined;
  inverted?: boolean | undefined;
  className?: string | undefined;
}) {
  const theme = useResolvedTheme();
  const light = inverted ?? theme === 'dark';

  return (
    <img
      src={light ? '/marca-invertida.png' : '/marca.png'}
      alt=""
      width={Math.round(size * RATIO)}
      height={size}
      className={cn('shrink-0', className)}
      style={{ width: Math.round(size * RATIO), height: size }}
    />
  );
}

export function BrandLockup({
  size = 28,
  inverted,
  subtitle,
}: {
  size?: number | undefined;
  inverted?: boolean | undefined;
  subtitle?: string | undefined;
}) {
  return (
    <span className="flex items-center gap-2.5">
      <BrandMark size={size} inverted={inverted} />
      <span className="flex min-w-0 flex-col leading-tight">
        <span
          className={cn(
            'text-[15px] font-semibold tracking-tight',
            inverted ? 'text-rail-ink' : 'text-ink',
          )}
        >
          Obras Hoje
        </span>
        {subtitle ? (
          <span className={cn('truncate text-[11px]', inverted ? 'text-rail-muted' : 'text-ink-3')}>
            {subtitle}
          </span>
        ) : null}
      </span>
    </span>
  );
}
